import { DropdownMenuHorizontalOutlined } from '@icon';
import React from 'react';
import Dropdown, { DropdownProps } from '../../../dropdown';
import IconButton from '../../../icon-button';

interface TableActionProps extends NonNullable<DropdownProps['menu']> {}

const TableAction: React.FunctionComponent<TableActionProps> = (props) => {
  return (
    <Dropdown menu={props} placement="bottomRight">
      <IconButton
        Icon={DropdownMenuHorizontalOutlined}
        variant="secondary"
        size="small"
        shape="round"
      />
    </Dropdown>
  );
};

export default TableAction;
